var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRewardsIllustration = function SvgRewardsIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 45,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#rewards-illustration_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rewards-illustration_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 0.911,
    y: 0.455,
    fill: "url(#rewards-illustration_svg__c)",
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rewards-illustration_svg__d)",
    filter: "url(#rewards-illustration_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.911 20.633c.496 0 .899.403.899.899 0 .708.347 1.463.94 2.055.591.593 1.346.94 2.055.94a.9.9 0 0 1 0 1.798c-.709 0-1.464.347-2.056.94-.592.591-.94 1.347-.94 2.055l-.004.092a.898.898 0 0 1-1.793-.092c0-.708-.347-1.463-.94-2.056-.592-.592-1.347-.94-2.055-.94a.899.899 0 0 1 0-1.797c.708 0 1.463-.347 2.055-.94.593-.592.94-1.347.94-2.055a.9.9 0 0 1 .9-.899Zm8.388-9.585c.496 0 .898.402.898.898 0 1.505.408 2.878 1.128 3.85.703.948 1.717 1.541 3.066 1.541a.9.9 0 0 1 0 1.798c-1.309 0-2.299.559-2.997 1.452-.715.916-1.141 2.212-1.192 3.65l-.005.29-.005.092a.898.898 0 0 1-1.793-.092c0-1.505-.407-2.878-1.127-3.85-.703-.949-1.717-1.542-3.066-1.542a.899.899 0 0 1 0-1.798c1.349 0 2.363-.593 3.066-1.54.72-.973 1.128-2.346 1.128-3.851a.9.9 0 0 1 .899-.899Z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rewards-illustration_svg__b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 0.911,
    y: 0.455,
    fill: "#fff",
    rx: 8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rewards-illustration_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.87 9.41h22.09V31.5H9.87z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "rewards-illustration_svg__a",
    width: 41.821,
    height: 45.008,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.228
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.482353 0 0 0 0 0.658824 0 0 0 0 0 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_9329"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.455
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.228
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.482353 0 0 0 0 0.658824 0 0 0 0 0 0 0 0 0.42 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_31_9329",
    result: "effect2_dropShadow_31_9329"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.455
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.482353 0 0 0 0 0.658824 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_31_9329",
    result: "effect3_dropShadow_31_9329"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.277
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.455
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.482353 0 0 0 0 0.658824 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect3_dropShadow_31_9329",
    result: "effect4_dropShadow_31_9329"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.643
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.455
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.482353 0 0 0 0 0.658824 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect4_dropShadow_31_9329",
    result: "effect5_dropShadow_31_9329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect5_dropShadow_31_9329",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "rewards-illustration_svg__e",
    width: 30.286,
    height: 36.66,
    x: 5.771,
    y: 8.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.455
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.683
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_9329"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.277
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.138
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_31_9329",
    result: "effect2_dropShadow_31_9329"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.464
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.594
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_31_9329",
    result: "effect3_dropShadow_31_9329"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.562
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.049
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect3_dropShadow_31_9329",
    result: "effect4_dropShadow_31_9329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect4_dropShadow_31_9329",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rewards-illustration_svg__c",
    x1: 20.911,
    x2: 20.911,
    y1: 0.455,
    y2: 40.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46DA93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89F399"
  })))));
};
export default SvgRewardsIllustration;